module.exports = __webpack_public_path__ + "static/media/sign-in-background.68f5e88c.png";